import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getPendencias } from "../services/pendenciaService";
import styled from "styled-components";

const Container = styled.div`
  padding: 5%;
  background-color: #fff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  font-size: 3rem; /* Ajustado para tamanho maior */
  font-weight: normal;
  margin-bottom: 4%;
  text-align: center;
`;

const PendenciaItem = styled.div`
  background: #f5f5f5;
  padding: 4%; /* Aumentado para melhorar usabilidade */
  margin-bottom: 3%;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  font-size: 1rem; /* Para maior legibilidade */
`;

const PendenciaTitle = styled.div`
  font-size: 1.2rem; /* Ajustado para melhor visibilidade */
  font-weight: bold;
  margin-bottom: 2%;
`;

const PendenciaSubtitle = styled.div`
  font-size: 1.2rem; /* Ajustado para tela pequena */
  color: #555;
  margin-top: 2%;
`;

const PendenciaDetails = styled.div`
  font-size: 1.1rem; /* Ajustado para melhor leitura */
  color: #777;
  margin-top: 2%;
`;

const PendenciasMobileList = () => {
  const [pendencias, setPendencias] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPendencias = async () => {
      try {
        const data = await getPendencias(1);
        setPendencias(data.pendencias);
      } catch (error) {
        console.error("Erro ao buscar pendências:", error);
      }
    };
    fetchPendencias();
  }, []);

  return (
    <Container>
      <Header>Lista de Pendências</Header>
      {pendencias.map(pendencia =>
        <PendenciaItem
          key={pendencia._id}
          onClick={() => navigate(`/pendencias-mobile/${pendencia._id}`)}
        >
          <PendenciaTitle>
            {pendencia.building || "Técnico Não Informado"}
          </PendenciaTitle>
          <PendenciaDetails>
            {pendencia.address || "Não Informado"}
            <br />
            {pendencia.equipamentoNumero || "Não Informado"}
          </PendenciaDetails>
          <PendenciaSubtitle>
            {pendencia.descricaoPendencia}
          </PendenciaSubtitle>
        </PendenciaItem>
      )}
    </Container>
  );
};

export default PendenciasMobileList;
